//
//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ActivityEnum, AlertLevelEnum } from '@shared/Enums'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { dispatchError, OtStoreState } from '@react/redux/store'

import { ETH_ADDR_ZERO, ProviderReadOnly } from '@shared/SchemaTypes'
import { alertActions } from '@react/redux/alertSlice'

import { chainActions } from '@react/redux/chainSlice'

export const fetchChainTimestampDeltaTx =
  (): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    logOT.info('fetchChainTimestampDeltaTx Start')
    const activity = ActivityEnum.FECTH_CHAIN_TIMESTAMP_DELTA
    try {
      logOT.debug(activity)

      if (!getState().chainState.chainConfiguration) {
        logOT.info('fetchChainTimestampDeltaTx no stageConfiguration')
        return
      }
      const { isShutdown, chainConfiguration } = getState().chainState
      const { providerReadOnly } = chainConfiguration
      if (!providerReadOnly) {
        logOT.info('fetchChainTimestampDeltaTx providerReadOnly is undefined')
        return
      }

      if (isShutdown) {
        logOT.info('fetchChainTimestampDeltaTx isShutdown')
        return
      }

      const chainTimestampDelta = await fetchChainTimestampDelta(providerReadOnly)

      dispatch(chainActions.updateChainTimeDelta({ chainTimestampDelta }))
    } catch (e: any) {
      logOT.error('fetchChainTimestampDeltaTx 2', e)
      dispatch(
        alertActions.addAlert({
          title: 'Cound not verify Chain time stamp',
          description: 'Cound not verify Chain time stamp',
          createdAt: Date.now() / 1000,
          dueDateTime: Date.now() / 1000,
          txHash: '',
          sourceObjectAddr: ETH_ADDR_ZERO,
          alertLevel: AlertLevelEnum.ERROR,
        })
      )
      await dispatchError(dispatch, e, activity, 1027)
    }
  }
export const fetchChainTimestampDelta = async (providerReadOnly: ProviderReadOnly): Promise<number> => {
  let chainTimestamp = 0
  let blockNumber = 0
  let retrys = 0
  let success = false
  while (!success && retrys < 5) {
    try {
      blockNumber = await providerReadOnly.getBlockNumber()
      const blockStart = await providerReadOnly.getBlock(blockNumber)
      chainTimestamp = blockStart?.timestamp ?? 0

      success = true
    } catch (e) {
      logOT.info('fetchChainTime Retry', e)
      retrys++
    }
  }
  const currentTime = Math.round(Date.now() / 1000)
  const chainTimestampDelta = chainTimestamp - currentTime
  // if (chainTimestampDelta < 360) {
  //   chainTimestampDelta = 0
  // }

  return chainTimestampDelta
}
